import { render, staticRenderFns } from "./ContactDetailItem.vue?vue&type=template&id=44b86af2&scoped=true"
import script from "./ContactDetailItem.vue?vue&type=script&lang=js"
export * from "./ContactDetailItem.vue?vue&type=script&lang=js"
import style0 from "./ContactDetailItem.vue?vue&type=style&index=0&id=44b86af2&prod&lang=scss&scoped=true"
import style1 from "./ContactDetailItem.vue?vue&type=style&index=1&id=44b86af2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b86af2",
  null
  
)

export default component.exports